import { logoSrc } from '../platformLogos';

export interface LogoProps {
  /** domain of a committed `public/platform-logos/<domain>.png` */
  domain: string;
  /** the brand's name, drawn after the mark and used as its alt text */
  name: string;
  /** draw the mark alone; `name` stays as the alt text */
  iconOnly?: boolean;
}

/**
 * A brand's mark inline with its name, sized to the surrounding text, so a
 * comparison post can show which vendor or platform a row, bullet, or
 * sentence is about at a glance.
 */
export const Logo = ({ domain, name, iconOnly = false }: LogoProps) => (
  // Plain inline, not inline-flex: a flex box is an atomic inline, so the line
  // could break between the name and a comma that follows it.
  <span className="whitespace-nowrap">
    <img
      src={logoSrc(domain)}
      alt={iconOnly ? name : ''}
      title={iconOnly ? name : undefined}
      loading="lazy"
      decoding="async"
      className="inline-block"
      // `max-width: none` beats the base `img { max-width: 100% }`, which makes
      // a table count the mark as zero wide and squeeze the name past the border.
      style={{
        width: '1.15em',
        height: '1.15em',
        maxWidth: 'none',
        marginRight: iconOnly ? 0 : '0.35em',
        verticalAlign: '-0.2em',
        borderRadius: 4,
        objectFit: 'contain',
      }}
    />
    {iconOnly ? null : name}
  </span>
);
